<template>
    <td class="py-0 text-right">
        <ButtonGroup v-if="editing" class="inline-block">
            <Button variant="danger" :size="buttonSize" @click="emits('cancel')">
                <Icon name="cancel" />
                <span v-if="mdAndLarger">{{ $t("Global.Cancel") }}</span>
            </Button>
            <Button variant="primary" :size="buttonSize" @click="emits('save')">
                <Icon name="save" />
                <span v-if="mdAndLarger">{{ $t("Notifications.Save") }}</span>
            </Button>
        </ButtonGroup>
        <ButtonGroup v-else class="inline-block">
            <Button variant="danger" :size="buttonSize" :disabled @click="emits('delete')">
                <Icon name="trash-can" />
                <span v-if="mdAndLarger">{{ $t("Global.Delete") }}</span>
            </Button>
            <Button variant="primary" :size="buttonSize" :disabled @click="emits('edit')">
                <Icon name="edit" />
                <span v-if="mdAndLarger">{{ $t("Global.Edit") }}</span>
            </Button>
        </ButtonGroup>
    </td>
</template>

<script setup lang="ts">
import type { ButtonVariants } from "~/components/ui";
const breakpoints = useBreakpoints();

const { editing = false, disabled = false } = defineProps<{ editing?: boolean; disabled?: boolean }>();

const emits = defineEmits(["cancel", "save", "delete", "edit"]);

const mdAndLarger = breakpoints.greaterOrEqual("md");

const buttonSize = computed<ButtonVariants["size"]>(() => (mdAndLarger.value ? "sm" : "icon"));
</script>
